import { graphql, HttpResponse } from 'msw'
import { type EnrollmentJointHomeAddressData, type EnrollmentJointHomeAddressSubmitOutput } from '../../../../models'

export const getEnrollmentJointHomeAddressDataMock: EnrollmentJointHomeAddressData = {
  // accountType: 'COMMUNITY_PROPERTY',
  activePerson: {
    applicationId: '1234567890',
    path: '/enrollment/joint/home-address',
    progress: 50,
    isInitiator: true,
    name: {
      firstName: 'John',
      lastName: 'Doe',
    },
    addressLine1: '123 Main St',
    addressLine2: 'Apt 4B',
    addressCity: 'New York',
    addressRegionCode: 'NY',
    addressPostalCode: '10001',
    addressCountry: 'US',
  },
  jointPerson: {
    addressLine1: '123 Main St',
    addressLine2: 'Apt 4B',
    addressCity: 'New York',
    addressRegionCode: 'NY',
    addressPostalCode: '10001',
    addressCountry: 'US',
  },
  isError: false,
  errors: [],
}

export const submitEnrollmentJointHomeAddressDataMock: EnrollmentJointHomeAddressSubmitOutput = {
  isError: false,
  errors: [],
  activePerson: {
    path: '/enrollment/joint/employment',
  },
}

export const mockGetEnrollmentJointHomeAddressData = graphql.mutation('getEnrollmentJointHomeAddressData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: getEnrollmentJointHomeAddressDataMock } })
})

export const mockSubmitEnrollmentJointHomeAddressData = graphql.mutation('submitEnrollmentJointHomeAddressData', () => {
  return HttpResponse.json({ data: { submitJointEnrollment: submitEnrollmentJointHomeAddressDataMock } })
})

export const mockEnrollmentJointHomeAddress = [
  mockGetEnrollmentJointHomeAddressData,
  mockSubmitEnrollmentJointHomeAddressData,
]
